import { render, staticRenderFns } from "./index.vue?vue&type=template&id=082403e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../assets/css/list.scss?vue&type=style&index=0&id=082403e6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082403e6",
  null
  
)

export default component.exports